import { styled } from '@uhg-abyss/web/tools/styled';

import { Markdown } from '../../../../common/Markdown';

export const PrimaryBoldText = styled('span', {
  color: '$core.color.brand.100 !important',
  fontWeight: 'bold',
});

export const TitleStyle = styled('span', {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
});

export const HeadingStyle = styled('span', {
  color: '#4B4D4F',
  fontSize: '18px',
  fontWeight: 'bold',
  marginRight: '4px',
  whiteSpace: 'nowrap',
});

export const SubTitleStyle = styled('span', {
  color: '$core.color.brand.60',
  fontWeight: '600',
  cursor: 'pointer',
  fontSize: '18px !important',
  whiteSpace: 'nowrap',
  display: 'flex',
  alignItems: 'center',
});

export const textStyle = {
  marginTop: '20px',
  display: 'flex',
  alignItems: 'center',
};

export const titleTextStyle = {
  '&.abyss-heading-root': {
    fontSize: '22.78px',
    color: '#4B4D4F !important',
    fontWeight: '400 !important',
    '@media (max-width: 744px)': {
      fontSize: '20.25px !important',
    },
  },
};

export const ResultTitleMarkdown = styled(Markdown, {
  // Only affect spans inside this specific Markdown block
  '& span': {
    color: '$primary1 !important',
    fontWeight: 'bold',
  },
});
